import React from 'react';
import Shell from 'components/Shell/Shell';
import NewsSection from 'containers/Sections/NewsSection';
import { getMasterControl, getNews, getBlogs } from '@viome/vnxt-nucleus';
import { contentfulOptions as options } from 'utils/constants';

const News = (props) => {
    const { preview, masterControl, page } = props;
    return (
        <Shell masterControl={masterControl} page={page} preview={preview}>
            <NewsSection props={props} />
        </Shell>
    );
};

export default News;

export const getStaticProps = async ({ preview = false }) => {
    const pageData = Promise.all([
            getMasterControl.get(options),
            getNews.getNewsIndex(options),
            getNews.getNewsArticles(options),
            getBlogs.getBlogsByDateDESC(options),
        ]),
        props = await pageData.then(
            async ([masterControl, page, articles, blogs]) => ({
                preview,
                masterControl,
                page,
                articles,
                blogs,
            }),
        );

    return { props, revalidate: 60 };
};
